import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";

import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingWhatsApp";
import WelcomePopup from "./components/WelcomePopup";
import SplashIntro from "./components/SplashIntro";

import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import Legal from "./pages/Legal";
import ReviewQR from "./pages/ReviewQR";

function ScrollToHash() {
    const { hash, pathname } = useLocation();
    useEffect(() => {
        if (hash) {
            const el = document.querySelector(hash);
            if (el)
                setTimeout(
                    () =>
                        el.scrollIntoView({ behavior: "smooth", block: "start" }),
                    50
                );
        } else {
            window.scrollTo({ top: 0, behavior: "instant" });
        }
    }, [hash, pathname]);
    return null;
}

function App() {
    return (
        <div className="App bg-[#0a0a0c] text-[#f4efe4]">
            <SplashIntro />
            <BrowserRouter>
                <ScrollToHash />
                <Header />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/hizmet/:slug" element={<ServiceDetail />} />
                    <Route path="/yorum-birak" element={<ReviewQR />} />
                    <Route path="/kvkk" element={<Legal type="kvkk" />} />
                    <Route path="/gizlilik" element={<Legal type="gizlilik" />} />
                    <Route path="/cerez" element={<Legal type="cerez" />} />
                </Routes>
                <Footer />
                <FloatingActions />
                <WelcomePopup />
            </BrowserRouter>
        </div>
    );
}

export default App;
